<template>
  <section class="page">
    <slot></slot>
  </section>
</template>

<style scoped>

  .page {
    position: relative;

    display: flex;
    flex-direction: column;

    max-width: 100vw;
    min-height: 100vh;
    max-height: 100vh;

    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

</style>